// import React, { useState } from 'react';
// import {
//     Box,
//     Card,

//     Typography,

//     Button,
//     Divider,
//     Grid,
//     RadioGroup,
//     Radio,
//     FormControlLabel,
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     IconButton,
//     Checkbox,

// } from '@mui/material';
// import { Close as CloseIcon } from '@mui/icons-material';

// import '../../ContentManagement/Home/Modal/BannerinputGetModal.css' // Import external CSS
// import { MdCancel } from "react-icons/md";

// import cardImage2 from "../../../Assets/home_page_Image.png";
// import cardImage1 from "../../../Assets/sheme_small_image.png";
// import { CiSquarePlus, CiSquareMinus } from "react-icons/ci";
// import { Formik, Form, Field } from "formik";

// import { AiFillThunderbolt } from "react-icons/ai";
// import { Link, useNavigate } from "react-router-dom";

// const PaymentSummaryModal = ({ open, onClose, setSubmittedValues, submittedValues, modalHeadingName,handleNextModal}) => {
//     const [cartItems, setCartItems] = useState([
//         { id: 1, name: "Scheme 1", price: 1000, quantity: 1, image: cardImage1 },
//         { id: 2, name: "Scheme 2", price: 10000, quantity: 1, image: cardImage2 },
//     ]);

//     const handleQuantityChange = (id, delta) => {
//         setCartItems((prevItems) =>
//             prevItems.map((item) =>
//                 item.id === id
//                     ? { ...item, quantity: Math.max(1, item.quantity + delta) }
//                     : item
//             )
//         );
//     };

//     const subtotal = cartItems.reduce(
//         (total, item) => total + item.price * item.quantity,
//         0
//     );

//     const initialValues = {
//         paymentMethod: "Cash", // Default selected payment method
//     };

//     const navigate = useNavigate()

//     const handleSubmit = (values) => {
//         console.log("Selected Payment Method:", values.paymentMethod);
//         // navigate("/Customer-dashboard")
//         handleNextModal()
//     };

//     return (
//         <Dialog
//             open={open}
//             onClose={onClose}
//             fullWidth
//             maxWidth="md"
//             className="custom-dialog"
//             sx={{
//                 "& .MuiPaper-root": {
//                     maxWidth: "800px",
//                     borderRadius: "14px", // Target the Paper component
//                 },
//             }}
//         >
//             <Box sx={{ position: 'relative' }}>
//                 <Box className="dialog-heading">
//                     <IconButton
//                         aria-label="Close"
//                         onClick={onClose}
//                         sx={{ position: 'absolute', top: 8, right: 8, color: 'text.secondary' }}
//                     >
//                         <MdCancel />
//                     </IconButton>
//                     <DialogTitle className="custom-dialog-title">
//                         <Box>
//                             <Typography className="custom-title-text" color='white'>
//                                 {/* {modalHeadingName} */}
//                                 Payment Summary
//                             </Typography>
//                         </Box>
//                     </DialogTitle>
//                 </Box>

//                 <DialogContent
//                     dividers
//                     sx={{
//                         padding: 0, // Removes the padding completely
//                         '& .MuiDialogContent-root': {
//                             padding: 0, // Ensures no padding inside DialogContent
//                         },
//                     }}
//                 >
//                     <>
//                         {/* <MyAppBar /> */}

//                         <Grid
//                             container
//                             spacing={2}
//                             sx={{ p: { xs: 2, md: 4 }, flexDirection: { xs: "column", md: "row" } }}
//                         >
//                             {/* Product Table */}

//                             {/* Order Summary */}
//                             <Grid item xs={12} md={7}>
//                                 <Card
//                                     sx={{
//                                         p: 2,
//                                         background: "#F7F7F7",
//                                         border: "none",
//                                         boxShadow: "none",
//                                     }}
//                                 >
//                                     <Typography
//                                         variant="h5"
//                                         // gutterBottom
//                                         sx={{
//                                             color: "#252525",
//                                             // fontWeight: 700,
//                                             // fontSize: "16px",
//                                         }}
//                                     >
//                                         Order Summary
//                                     </Typography>
//                                     {/* <Divider /> */}
//                                     {cartItems.map((item) => (
//                                         <Box
//                                             key={item.id}
//                                             sx={{
//                                                 display: "flex",
//                                                 justifyContent: "space-between",
//                                                 mt: 2,
//                                             }}
//                                         >
//                                             <Typography
//                                                 variant="body1"
//                                                 sx={{
//                                                     // fontSize: "14px",
//                                                     color: "#7A7A7A",
//                                                 }}
//                                             >
//                                                 {item.quantity}x {item.name}
//                                             </Typography>
//                                             <Typography
//                                                 variant="body1"
//                                                 sx={{
//                                                     // fontSize: "14px",
//                                                     color: "#7A7A7A",
//                                                 }}
//                                             >
//                                                 ${item.price * item.quantity}
//                                             </Typography>
//                                         </Box>
//                                     ))}
//                                     <Divider sx={{ my: 2 }} />
//                                     <Box
//                                         sx={{
//                                             display: "flex",
//                                             justifyContent: "space-between",
//                                         }}
//                                     >
//                                         <Typography
//                                             variant="h5"
//                                         // sx={{ fontWeight: 700, fontSize: "16px" }}
//                                         >
//                                             Sub Total
//                                         </Typography>
//                                         <Typography
//                                             variant="h5"
//                                             sx={{
//                                                 // fontSize: "16px",
//                                                 color: "#C38F51",
//                                             }}
//                                         >
//                                             ${subtotal}
//                                         </Typography>
//                                     </Box>

//                                 </Card>
//                             </Grid>
//                             <Grid item xs={12} md={5}>
//                                 <Card
//                                     sx={{
//                                         p: 2,
//                                         background: "#F7F7F7",
//                                         border: "none",
//                                         boxShadow: "none",
//                                     }}
//                                 >
//                                     <Typography
//                                         variant="h5"
//                                         // gutterBottom
//                                         sx={{
//                                             color: "#252525",
//                                             // fontWeight: 700,
//                                             // fontSize: "16px",
//                                         }}
//                                     >
//                                         Payment Type
//                                     </Typography>

//                                     <Formik
//                                         initialValues={{ paymentMethod: "", privacyChecked: false }}
//                                         onSubmit={handleSubmit}
//                                     >
//                                         {({ values }) => (
//                                             <Form>
//                                                 <Box mt={2}>
//                                                     <RadioGroup name="paymentMethod">
//                                                         <Field
//                                                             as={FormControlLabel}
//                                                             type="radio"
//                                                             name="paymentMethod"
//                                                             value="Cash"
//                                                             control={
//                                                                 <Radio
//                                                                     sx={{
//                                                                         color: "#3B4056",
//                                                                         "&.Mui-checked": {
//                                                                             color: "#C38F51",
//                                                                         },
//                                                                     }}
//                                                                 />
//                                                             }
//                                                             label="Cash"
//                                                         />
//                                                         <Field
//                                                             as={FormControlLabel}
//                                                             type="radio"
//                                                             name="paymentMethod"
//                                                             value="Payment Gateway"
//                                                             control={
//                                                                 <Radio
//                                                                     sx={{
//                                                                         color: "#3B4056",
//                                                                         "&.Mui-checked": {
//                                                                             color: "#C38F51",
//                                                                         },
//                                                                     }}
//                                                                 />
//                                                             }
//                                                             label="Payment Gateway"
//                                                         />
//                                                     </RadioGroup>
//                                                 </Box>
//                                                 <Box mt={2}>
//                                                     <Typography component="div">
//                                                         <Field
//                                                             as={FormControlLabel}
//                                                             name="privacyChecked"
//                                                             control={
//                                                                 <Checkbox
//                                                                     sx={{
//                                                                         color: "#3B4056",
//                                                                         "&.Mui-checked": {
//                                                                             color: "#C38F51",
//                                                                         },
//                                                                     }}
//                                                                 />
//                                                             }
//                                                             label={
//                                                                 <Typography variant="body1">
//                                                                     You have read the{" "}
//                                                                     <span style={{ color: "red" }}>
//                                                                         <Link href="#" underline="hover"  style={{color:'#C38F51'}}>purchase documents</Link>
//                                                                     </span>{" "}
//                                                                     and other documents carefully.
//                                                                 </Typography>
//                                                             }
//                                                         />
//                                                     </Typography>

//                                                 </Box>
//                                                 <Box
//                                                     sx={{
//                                                         display: "flex",
//                                                         justifyContent: "center",
//                                                         alignItems: "center",
//                                                     }}
//                                                 >
//                                                     <Button
//                                                         type="submit"
//                                                         variant="contained"
//                                                         startIcon={<AiFillThunderbolt />}
//                                                         sx={{
//                                                             textTransform: "none",
//                                                             color: "white",
//                                                             padding: "7px 20px",
//                                                             mt: 2,
//                                                             minHeight: "30px",
//                                                             borderRadius: "23px",
//                                                             background:
//                                                                 "#C38F51 0% 0% no-repeat padding-box",
//                                                         }}
//                                                         disabled={!values.privacyChecked} // Disable button if checkbox is not checked
//                                                     >
//                                                         Pay${subtotal}
//                                                     </Button>
//                                                 </Box>
//                                             </Form>
//                                         )}
//                                     </Formik>

//                                 </Card>
//                             </Grid>
//                         </Grid>

//                         {/* <Footer /> */}
//                     </>
//                 </DialogContent>
//             </Box>
//         </Dialog>
//     );
// };

// export default PaymentSummaryModal;

import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Typography,
  Button,
  Divider,
  Grid,
  RadioGroup,
  Radio,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Checkbox,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

import "../../ContentManagement/Home/Modal/BannerinputGetModal.css"; // Import external CSS
import { MdCancel } from "react-icons/md";

import cardImage2 from "../../../Assets/home_page_Image.png";
import cardImage1 from "../../../Assets/sheme_small_image.png";
import { CiSquarePlus, CiSquareMinus } from "react-icons/ci";
import { Formik, Form, Field } from "formik";

import { AiFillThunderbolt } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import { adminUrl } from "../../../constants";
import { useSelector, useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import actions from "../../../ReduxStore/actions";
import ReadDocumentsModal from "./ReadDocumentsModal";
import { clearCustomerId } from "../../../ReduxStore/Slices/Operator/customerSlice";

const PaymentSummaryModal = ({
  open,
  onClose,
  setSubmittedValues,
  submittedValues,
  modalHeadingName,
  handleNextModal,
  handleSummeryModalOpen
}) => {
  //   const [cartItems, setCartItems] = useState([
  //     { id: 1, name: "Scheme 1", price: 1000, quantity: 1, image: cardImage1 },
  //     { id: 2, name: "Scheme 2", price: 10000, quantity: 1, image: cardImage2 },
  //   ]);

  const handleQuantityChange = (id, delta) => {
    setCartItems((prevItems) =>
      prevItems.map((item) =>
        item.id === id
          ? { ...item, quantity: Math.max(1, item.quantity + delta) }
          : item
      )
    );
  };
  const customerId = useSelector((state) => state.customer);

  //   const subtotal = cartItems.reduce(
  //     (total, item) => total + item.price * item.quantity,
  //     0
  //   );

  //   const initialValues = {
  //     paymentMethod: "Cash", // Default selected payment method
  //   };

  //   const navigate = useNavigate();

  //   const handleSubmit = (values) => {
  //     console.log("Selected Payment Method:", values.paymentMethod);
  //     // navigate("/Customer-dashboard")
  //     handleNextModal();
  //   };

  const [cartItems, setCartItems] = useState([]);
  const [subtotal, setSubtotal] = useState();
  const [rowTableData, setRowTableData] = useState([]);

  const sessioncustomer_id = sessionStorage.getItem("sessioncustomer_id");
  const sessionFirstName = sessionStorage.getItem("sessionFirstName");

  const cartItemsLocal = useSelector((state) => state.cart.cart);
  const { getCartItems } = useSelector((state) => state?.getCartItems);
  const { clearCart } = useSelector((state) => state?.clearCart);
  const dispatch = useDispatch();
  // const [cartItems, setCartItems] = useState([
  //     { id: 1, name: "Scheme 1", price: 1000, quantity: 1, image: cardImage1 },
  //     { id: 2, name: "Scheme 2", price: 10000, quantity: 1, image: cardImage2 },
  // ]);

  const [isDocumentModalOpen, setDocumentModalOpen] = useState(false);

  const handleDocumentOpenModal = () => {
    setDocumentModalOpen(true);
  };

  const handleDocumentCloseModal = () => {
    setDocumentModalOpen(false);
  };

  // const handleQuantityChange = (id, delta) => {
  //     setCartItems((prevItems) =>
  //         prevItems.map((item) =>
  //             item.id === id
  //                 ? { ...item, quantity: Math.max(1, item.quantity + delta) }
  //                 : item
  //         )
  //     );
  // };

  useEffect(() => {
    if (!open) return; // Only fetch when modal is open

    const fetchData = async () => {
      try {
        const data1 = {
          data: {},
          method: "get",
          apiName: `getCartItems/${customerId.customerId}`,
        };
        await dispatch(actions.GETCARTTREMS(data1));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      fetchData();
    }
  }, [dispatch, customerId.customerId, open]);

  useEffect(() => {
    const tempArr = [];
    getCartItems?.data?.cart_items?.map((item, index) => {
      return tempArr.push({
        plan_id: item.plan_id,
        title: item.plan_details.title,
        value_of_purchase: item.plan_details.value_of_purchase,
        image_url: `${adminUrl}/${item.image_url}`,
        quantity: item.quantity,
      });
    });
    setRowTableData(tempArr);
  }, [dispatch, getCartItems]);

  useEffect(() => {
    // if (sessioncustomer_id) {
    // Determine cart items dynamically
    // const cartItemsDynamic = JSON.parse(sessioncustomer_id) !== null ? rowTableData : cartItemsLocal;
    // console.log(cartItemsDynamic, "cartItemsDynamic");
    // setCartItems(cartItemsDynamic)

    // const cartItems2 = JSON.parse(sessioncustomer_id) !== null ? "apiii" : "local";

    // console.log(cartItems2, "cartItems2cartItems2");

    setCartItems(rowTableData);

    const subtotal = rowTableData.reduce(
      (total, item) => total + item.value_of_purchase * item.quantity,
      0
    );

    setSubtotal(subtotal);

    // }
  }, [customerId, cartItemsLocal, getCartItems, rowTableData]);

  // const subtotal = cartItems.reduce(
  //     (total, item) => total + item.value_of_purchase * item.quantity,
  //     0
  // );

  const sessionOperator_id = sessionStorage.getItem("sessionOperator_id");
  const UserRole = sessionStorage.getItem("UserRole");


  const handleClearCustomerId = () => { };

  const initialValues = {
    paymentMethod: "Cash", // Default selected payment method
  };

  const navigate = useNavigate();

  const { addMultiPurchase } = useSelector((state) => state?.addMultiPurchase);

  console.log(addMultiPurchase);

  const handleSubmit = async (values) => {
    console.log("Selected Payment Method:", values.paymentMethod);

    const transformedCartItems = cartItems.map((item) => ({
      plan_id: item.plan_id, // Adjust plan_id offset
      purchase_time: item.quantity, // Map quantity to purchase_time
    }));

    const data1 = {
      data: {
        customer_id: customerId.customerId,
        payment_type: values.paymentMethod,
        purchase_contract_accepted: true,
        cart_items: transformedCartItems,
        userId: sessionOperator_id,
        userRole: UserRole
      },
      method: "post",
      apiName: "addMultiPurchaseBymanagement",
    };

    const addMultiPurchaseResponse = await dispatch(
      actions.ADDMULTIPURCHASE(data1)
    );

    //    console.log(addMultiPurchaseResponse.payload.message ==="Purchase added successfully.","addMultiPurchaseResponse");

    if (
      addMultiPurchaseResponse.payload.message ===
      "Purchase added successfully."
    ) {
      // // Clear the entire localStorage
      // localStorage.clear();

      // // Or if you only want to remove the 'cart' item specifically:
      // localStorage.removeItem('cart');

      // dispatch(clearCartLocalCart());
      console.log("sjdhdsjdsdjsjdks")
      const data1 = {
        data: {},
        method: "delete",
        apiName: `clearCart/${customerId.customerId}`,
      };
      dispatch(actions.CLEARCART(data1));

      toast.success(`${addMultiPurchaseResponse.payload.message}`);
      //   dispatch(clearCustomerId()); // Dispatch the action to clear the customerId

      setTimeout(() => {
        // navigate("/Customer-dashboard");
        handleNextModal();
      }, 2500);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      className="custom-dialog"
      sx={{
        "& .MuiPaper-root": {
          maxWidth: "800px",
          borderRadius: "14px", // Target the Paper component
        },
      }}
    >
      <Box sx={{ position: "relative" }}>
        <Box className="dialog-heading">
          <IconButton
            aria-label="Close"
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "text.secondary",
            }}
          >
            <MdCancel />
          </IconButton>
          <DialogTitle className="custom-dialog-title">
            <Box>
              <Typography className="custom-title-text" color="white">
                {/* {modalHeadingName} */}
                Payment Summary
              </Typography>
            </Box>
          </DialogTitle>
        </Box>

        <DialogContent
          dividers
          sx={{
            padding: 0, // Removes the padding completely
            "& .MuiDialogContent-root": {
              padding: 0, // Ensures no padding inside DialogContent
            },
          }}
        >
          <>
            {/* <MyAppBar /> */}

            <Grid
              container
              spacing={2}
              sx={{
                p: { xs: 2, md: 4 },
                flexDirection: { xs: "column", md: "row" },
              }}
            >
              {/* Product Table */}

              {/* Order Summary */}
              <Grid item xs={12} md={6}>
                <Card
                  sx={{
                    p: 2,
                    background: "#F7F7F7",
                    border: "none",
                    boxShadow: "none",
                  }}
                >
                  <Typography
                    variant="h5"
                    // gutterBottom
                    sx={{
                      color: "#252525",
                      // fontWeight: 700,
                      // fontSize: "16px",
                    }}
                  >
                    Order Summary
                  </Typography>
                  {/* <Divider /> */}
                  {cartItems.map((item) => (
                    <Box
                      key={item.plan_id}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mt: 2,
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          // fontSize: "14px",
                          color: "#7A7A7A",
                        }}
                      >
                        {item.quantity}x {item.title}
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          // fontSize: "14px",
                          color: "#7A7A7A",
                        }}
                      >
                        ${item.value_of_purchase * item.quantity}
                      </Typography>
                    </Box>
                  ))}
                  <Divider sx={{ my: 2 }} />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      variant="h5"
                    // sx={{ fontWeight: 700, fontSize: "16px" }}
                    >
                      Sub Total
                    </Typography>
                    <Typography
                      variant="h5"
                      sx={{
                        // fontSize: "16px",
                        color: "#C38F51",
                      }}
                    >
                      ${subtotal}
                    </Typography>
                  </Box>
                </Card>
              </Grid>
              <Grid item xs={12} md={6}>
                <Card
                  sx={{
                    p: 2,
                    background: "#F7F7F7",
                    border: "none",
                    boxShadow: "none",
                  }}
                >
                  <Typography
                    variant="h5"
                    // gutterBottom
                    sx={{
                      color: "#252525",
                      // fontWeight: 700,
                      // fontSize: "16px",
                    }}
                  >
                    Payment Type
                  </Typography>

                  <Formik
                    // initialValues={initialValues}
                    initialValues={{
                      paymentMethod: "cash",
                      privacyChecked: false,
                    }}
                    onSubmit={handleSubmit}
                  >
                    {({ values }) => (
                      <Form>
                        <Box mt={2}>
                          <RadioGroup name="paymentMethod">
                            <Field
                              as={FormControlLabel}
                              type="radio"
                              name="paymentMethod"
                              value="cash"
                              color="#3B4056"
                              control={
                                <Radio
                                  sx={{
                                    color: "#3B4056",
                                    "&.Mui-checked": {
                                      color: "#C38F51",
                                    },
                                  }}
                                />
                              }
                              label="Cash"
                            />
                            <Field
                              as={FormControlLabel}
                              type="radio"
                              name="paymentMethod"
                              value="NetBanking"
                              // control={<Radio color=""/>}
                              control={
                                <Radio
                                  sx={{
                                    color: "#3B4056",
                                    "&.Mui-checked": {
                                      color: "#C38F51",
                                    },
                                  }}
                                />
                              }
                              label="Payment Gateway"
                            />
                          </RadioGroup>
                        </Box>
                        <Box mt={2}>
                          <Typography component="div">
                            <Field
                              as={FormControlLabel}
                              name="privacyChecked"
                              control={
                                <Checkbox
                                  sx={{
                                    color: "#3B4056",
                                    "&.Mui-checked": {
                                      color: "#C38F51",
                                    },
                                  }}
                                />
                              }
                              label={
                                <Typography variant="body1">
                                  You have read the{" "}
                                  <span style={{ color: "red" }}>
                                    <Link
                                      href="#"
                                      underline="hover"
                                      onClick={handleDocumentOpenModal}
                                      style={{ color: "#C38F51" }}
                                    >
                                      purchase documents
                                    </Link>
                                  </span>{" "}
                                  and other documents carefully.
                                </Typography>
                              }
                            />
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Button
                            type="submit"
                            variant="contained"
                            startIcon={<AiFillThunderbolt />}
                            sx={{
                              textTransform: "none",
                              color: "white",
                              // fontSize: "16px",
                              padding: "7px 20px",
                              mt: 2,
                              minHeight: "30px",
                              borderRadius: "23px",
                              background: "#C38F51 0% 0% no-repeat padding-box",
                            }}
                            disabled={!values.privacyChecked} // Disable button if checkbox is not checked
                          >
                            Pay$
                            {getCartItems?.data?.cart_items?.overall_total
                              ? getCartItems?.data?.cart_items?.overall_total
                              : subtotal}
                          </Button>
                        </Box>
                      </Form>
                    )}
                  </Formik>
                </Card>
                <ReadDocumentsModal
                  open={isDocumentModalOpen}
                  onClose={handleDocumentCloseModal}
                  handleSummeryModalOpen={handleSummeryModalOpen}
                />
              </Grid>

              <ToastContainer
                position="top-right" // or "top-center", "bottom-left", etc.
                autoClose={1500} // Auto close duration in ms
                hideProgressBar={false} // Hide or show progress bar
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
              />
            </Grid>

            {/* <Footer /> */}
          </>
        </DialogContent>
      </Box>
    </Dialog>
  );
};

export default PaymentSummaryModal;
